
(function documentTypeModuleDefinition() {

    'use strict';

    angular.module('DocumentType', ['ui.router', 'Config', 'Entities', 'ErrorsExtend', 'dndLists'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function documentTypeConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('document-type-add', {
                    url: "/DocumentType/Add",
                    templateUrl: config.resourceUrl('/views/document-type/add-modify.html'),
                    controller: 'DocumentTypeAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTTYPE WRITE')
                });

                $stateProvider.state('document-type-modify', {
                    url: "/DocumentType/Modify/{id}",
                    templateUrl: config.resourceUrl('/views/document-type/add-modify.html'),
                    controller: 'DocumentTypeModifyController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTTYPE WRITE')
                });

                $stateProvider.state('document-type-find-menu', {
                    url: "/DocumentType/List/",
                    templateUrl: config.resourceUrl('/views/document-type/list.html'),
                    controller: 'DocumentTypeFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTTYPE READ').or('DOCUMENTTYPE WRITE')
                });

                $stateProvider.state('document-type-find', {
                    url: "/DocumentType/List/{name}",
                    templateUrl: config.resourceUrl('/views/document-type/list.html'),
                    controller: 'DocumentTypeFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTTYPE READ').or('DOCUMENTTYPE WRITE')
                });

                $stateProvider.state('document-type-detail', {
                    url: '/DocumentType/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/document-type/detail.html'),
                    controller: 'DocumentTypeDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTTYPE READ').or('DOCUMENTTYPE WRITE')
                });

                $stateProvider.state('document-type-metadata', {
                    url: '/DocumentType/AssociateMetadata/{id}',
                    templateUrl: config.resourceUrl('/views/document-type/associate-metadata.html'),
                    controller: 'DocumentTypeAssociateMetadataController'
                    , authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTTYPE WRITE')
                });

                $stateProvider.state('document-type-from-template', {
                    url: '/DocumentType/AddFromTemplate/{id}',
                    templateUrl: config.resourceUrl('/views/document-type/add-modify.html'),
                    controller: 'DocumentTypeFromTemplateController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTTYPE WRITE')
                });

                $stateProvider.state('document-type-import-settings', {
                    url: '/DocumentType/ImportSettings/{id}',
                    templateUrl: config.resourceUrl('/views/document-type/import-settings.html'),
                    controller: 'DocumentTypeImportSettingsController'
                    , authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTTYPE WRITE')
                });

                $stateProvider.state('document-type-import', {
                    url: '/DocumentType/Import/',
                    templateUrl: config.resourceUrl('/views/document-type/import.html'),
                    controller: 'DocumentTypeImportController'
                    , authorize: true,
                    roles: loginProvider.roleCondition('CTDT EXPORT IMPORT')
                });
            }
        ]);
})();